import { Injectable } from '@angular/core';

import { AppinfoService } from './appinfo.service';
import { CommonRequestService, PagingParam, SuccessResponse } from './common-request.service';
import { UserService } from './user.service';
import { Gfo } from './gfo.service';
import { LayerCategory } from './field-mapping.service';
import { AppSettings } from './../app.settings';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ModelMenuItemKey } from './main-data.service';
import WKT from 'ol/format/WKT';
import { Point } from 'ol/geom';

export type LayerLoadStateNum = 0 | 1 | 1.51 | 1.52 | 1.53 | 2 | 3 | 4 | 5;
export type LayerLoadStateName = 'MISSING' | 'CREATE' | 'SCHEMA' | 'TOPOLOGY' | 'DOMAIN' | 'CONTENT' | 'SUBMIT' | 'DISAPPROVE' | 'APPROVE';
export interface LayerLoadState {
	name: LayerLoadStateName;
	num: LayerLoadStateNum;
}
// export enum LayerLoadState {
// 	'APPROVE' = 5,
// 	'DISAPPROVE' = 4,
// 	'SUBMIT' = 3,
// 	'CONTENT' = 2,
// 	'DOMAIN' = 1.53,
//	'TOPOLOGY' = 1.52,
// 	'SCHEMA' = 1.51,
// 	'CREATE' = 1
// }

export type LayerMaintainType = 'LIVE' | 'REPLICA' | 'SNAPSHOT' | 'COLLABORATIVE';
export interface AppLayer {
	id: number;
	name: string;
	desc: string;
	category: LayerCategory;
	recordCount: number;
	loadDate: Date;
	isBuiltTopo: boolean;
	state: LayerLoadState;
	submitStatus?: { hasError: boolean; msg: string; }
	maintainType: LayerMaintainType;
	isFishbone?: false;
	cusId;
	// qcErrorCount?: number; // Qc error count
}
export interface FishboneLayer {
	layerType: 'FISHBONE';
	name: string;
	isFishbone: true;
	category: {
		code: string;
	}
	// id: number;
	// category?: LayerCategory;
}
export interface LayersRefreshed {
	cusId: number;
	layers: AppLayer[]
}
export interface BoundaryGeom {
	cusId: number;
	wkt: string; // latlong
	stateName: string;
}

export interface LoadableLayerType {
	code: string; // Layer type code
	loadable: boolean;
	maintainType: LayerMaintainType;
	usbId: number;
}
export interface TestLayer {
	id: number;
	code: string;
}

export interface BoundaryLayer {
	gltId; // Category id
	cateCode: string;
	label: string;
	layers: {
		id;
		maintainType;
		state: LayerLoadState;
	}[];
}

export type QaErrorLevel = 'CRITICAL' | 'WARNING' | null;

@Injectable()
export class LayerService {

	public layersRefreshed: Subject<LayersRefreshed> = new Subject();

	layerListBS: BehaviorSubject<{
		layers: AppLayer[];
		publishedLayers: AppLayer[];
		statusOnly?: boolean
	}> = new BehaviorSubject({
		layers: [],
		publishedLayers: []
	});
	// layerList: AppLayer[] = []; // Both loaded and UNloaded layers // Not including published layers
	// publishedLayerList: AppLayer[] = [];

	fishboneLayer: FishboneLayer= {
		layerType: 'FISHBONE',
		name: 'Fishbone Report',
		isFishbone: true,
		category: {
			code: 'fishbone'
		}
		// id: null,
		// category: null,
		// desc: null,
		// recordCount: null,
		// loadDate: null,
		// isBuiltTopo: null,
		// state: null,
		// maintainType: null
	};
	
	bdryLayerList: BoundaryLayer[] = [];

	constructor(
		private router: Router,
		private appinfoService: AppinfoService,
		private requestService: CommonRequestService,
		private userService: UserService
	) { }
	// Get raw layer list
	getRawLayers(customerId?: number, layerTypeId?: number, history?: boolean) {
		return new Promise<SuccessResponse<any[]>>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layers';
			customerId = customerId || this.userService.getUserInfo().customerId;
			const params: any = {
				customerId: customerId.toString()
			};
			if (layerTypeId) {
				params.layerId = layerTypeId.toString();
			}
			if (history) {
				params.history = true;
			}
			this.requestService.requestGet(url, {
				params: params
			}, rsp => resolve(rsp), err => reject(err));
		});
	}
	// Get layer list // The returned list does NOT include published layers
	getLayers(customerId?: number, statusOnly?: boolean, keepOriginalList?: boolean, layerTypeId?: number, history?: boolean) {
		console.log('gggggggggggg getLayers')
		return new Promise<AppLayer[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layers';
			const params: any = {};
			customerId = customerId || this.userService.getCustomerIdByType();
			if (!customerId) {
				resolve([]);
				return;
			}
			params.customerId = customerId.toString();
			if (layerTypeId) {
				params.layerId = layerTypeId.toString();
			}
			if (history) {
				params.history = true;
			}
			this.requestService.requestGet(url, {
				params: params
			}, (rsp: {data: any[]}) => {
				// const promises = [];
				const layers: AppLayer[] = [];
				const publishedLayers: AppLayer[] = [];
				if (rsp.data) {
					rsp.data.forEach((l) => {
						const layer: AppLayer = {
							id: l.gly_id,
							name: l.gly_name,
							desc: l.gly_desc,
							category: this.appinfoService.layerTypeList.find(t => t.id === l.gly_glt_id),
							recordCount: l.gly_rowcount,
							loadDate: l.gly_load_date,
							isBuiltTopo: l.is_topo_built,
							maintainType: l.gly_maint_type,
							cusId: l.gly_cus_id,
							// state: (() => {
							// 	var a;
							// 	a = Math.floor(Math.random() * 6);
							// 	return a;
							// })()
							state: ((): LayerLoadState => {
								return this.mapTextToLayerLoadState(l.lol_state);
								// switch (l.lol_state) {
								// 	case 'APPROVE': return 5;
								// 	case 'DISAPPROVE': return 4;
								// 	case 'SUBMIT': return 3;
								// 	case 'CONTENT': return 2;
								// 	case 'SCHEMA': return 1.51;
								// 	case 'TOPOLOGY': return 1.52;
								// 	case 'DOMAIN': return 1.53;
								// 	case 'CREATE': return 1;
								// 	default: return 0; // Not loaded layer
								// }
							})()
						};
						if (layer.maintainType === 'SNAPSHOT') {
							publishedLayers.push(layer);
						} else {
							layers.push(layer);
						}
						// if (layer.state === 2) {
						// 	promises.push(new Promise((resolveL, rejectL) => {
						// 		this.layerQcService.getQcErrorCount(l.gly_id)
						// 		.then((count) => {
						// 			layer.qcErrorCount = count;
						// 			resolveL();
						// 		}, err => rejectL(err));
						// 	}));
						// }
					});
				}
				// Promise.all(promises)
				// .catch((err) => {
				// 	console.log('Error on getting qcErrorCount: ', err);
				// 	resolve(layers);
				// })
				// .then(() => {
					if (!keepOriginalList) {
						this.layerListBS.next({
							layers: layers,
							publishedLayers: publishedLayers,
							statusOnly: statusOnly
						});
						// this.layerList = layers;
						// this.publishedLayerList = publishedLayers;
					}
					resolve(layers)
				// });
			}, err => reject(err));
		})
	}
	private mapTextToLayerLoadState(stateText: LayerLoadStateName): LayerLoadState {
		let num: LayerLoadStateNum;
		switch (stateText) {
			case 'APPROVE': num = 5; break;
			case 'DISAPPROVE': num = 4; break;
			case 'SUBMIT': num = 3; break;
			case 'CONTENT': num = 2; break;
			case 'SCHEMA': num = 1.51; break;
			case 'TOPOLOGY': num = 1.52; break;
			case 'DOMAIN': num = 1.53; break;
			case 'CREATE': num = 1; break;
			default: num = 0; break; // Not loaded layer
		}
		return {
			name: stateText,
			num: num
		};
	}
	getLiveLayerFromLayerList(layerList?: AppLayer[]) {
		layerList = layerList || this.layerListBS.getValue().layers;
		return layerList.filter(l => !!l.state && (l.maintainType === 'LIVE' || l.maintainType === 'COLLABORATIVE'));
	}
	// Get layer contents
	getLayerContents(layerId: number, gfo?: Gfo, paging?: PagingParam, model?: ModelMenuItemKey) {
		return new Promise<SuccessResponse<any[]>>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layerContents';
			const params: any = {
				glyId: layerId.toString()
			};
			// Set paging params
			if (paging) {
				this.requestService.setParamsPaging(params, paging);
			}
			// Set gfo
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			if (model) {
				params.model = model;
			}
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				resolve(rsp);
			}, async err => {
				reject(err);
			});
		});
	}
	getLayerGeometry(layerId: number, uuid?, gfo?: Gfo) {
		return new Promise<SuccessResponse<any[]>>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layerGeometry';
			const params: any = {
				layerId: layerId.toString(),
			};
			if (uuid) {
				params.uuId = uuid;
			}
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				resolve(rsp);
			}, async err => {
				// await this.checkLayerNotFoundError(err, cusId, layerId);
				reject(err);
			});
		});
	}

	deleteLayer(layerId: number, successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'azgiv/layers';
		this.requestService.requestDelete(url, {
			params: {
				layerId: layerId.toString(),
				userSubscriptionId: this.userService.getUserInfo().userSubId
			}
		}, (rsp) => {
			if (successCallback) {
				successCallback();
			}
		}, errorCallback);
	}
	purgeLayer(glyId: number, successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'azgiv/purgeLayer';
		const body = {
				glyId: glyId,
				userSubscriptionId: this.userService.getUserInfo().userSubId
		};
		this.requestService.requestPost(url, body, (rsp) => {
			if (successCallback) {
				successCallback();
			}
		}, errorCallback);
	}

	// Post
	publishLayers(layerIds: any[], restore?: boolean) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/publishLayers';
			const body: any = {
				layerIds: JSON.stringify(layerIds),
				userSubscriptionId: this.userService.getUserInfo().userSubId
			}
			if (restore) {
				body.restore = restore;
			}
			this.requestService.requestPost(url, body, rsp => {
				resolve(rsp);
			}, err => reject(err));
		});
	}

	updateLayerStatus(layerId: number, layerStatus: string) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layer';
			const body = {
				userSubscriptionId: this.userService.getUserInfo().userSubId,
				layerId: layerId,
				layerStatus: layerStatus
			};
			this.requestService.requestPut(url, body, rsp => resolve(rsp), err => reject(err));
		});
	}

	// Note: this is only for MatchPoint bdry use. For other NENA layer use Discrepancy Agency!!!
	getCustomerBoundaryGeom(customerId?: number) {
		return new Promise<BoundaryGeom[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/customerBoundaryGeom';
			const params = {
				customerId: customerId || this.userService.getUserInfo().customerId
			}
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				const boundaries: BoundaryGeom[] = [];
				if (rsp.data) {
					rsp.data.forEach(d => {
						boundaries.push({
							cusId: d.cus_id,
							wkt: d.geom,
							stateName: d.stn_name
						});
					});
				}
				resolve(boundaries);
			}, err => reject(err));
		});
	}

	getLayerGeomBoundingBox(layerId, extent, isGeojson?: boolean) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layerGeomBbox';
			const params = {
				layerId: layerId.toString(),
				xll: extent[0].toString(),
				yll: extent[1].toString(),
				xur: extent[2].toString(),
				yur: extent[3].toString(),
				geojson: isGeojson
			};
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				resolve(rsp.data);
			}, err => reject(err));
		});
	}

	getLoadableLayerTypeList(usbId, isTestLayer?: boolean) {
		return new Promise<LoadableLayerType[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layerTypeList';
			const params: any = {
				userSubscriptionId: usbId
			};
			if (isTestLayer) {
				params.test = isTestLayer;
			}
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				const loadable: LoadableLayerType[] = [];
				if (rsp.data) {
					rsp.data.forEach(i => {
						loadable.push({
							code: i.glt_cd,
							loadable: i.loadable,
							maintainType: i.gly_maint_type,
							usbId: i.usb_id
						})
					});
				}
				resolve(loadable);
			}, err => reject(err));
		});
	}
	// Get archive layer list
	getTestLayerList() {
		return new Promise<TestLayer[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layerTypeList';
			const params = {
				customerId: this.userService.customerInfo.id,
				test: true
			};
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				const layers: TestLayer[] = [];
				if (rsp.data) {
					rsp.data.forEach(i => {
						layers.push({
							code: i.glt_cd,
							id: i.gly_id
						})
					});
				}
				resolve(layers);
			}, err => reject(err));
		});
	}

	// Get boundary layers for reference use. It might not belong to current agency
	// Note: one type could have more than one layerIds
	getBdryLayers() {
		return new Promise<BoundaryLayer[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/layersBoundary';
			const params = {
				customerId: this.userService.getUserInfo().customerId
			}
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				const bdryLayers: BoundaryLayer[] = [];
				if (rsp.data) {
					rsp.data.forEach(d => {
						const cate = this.appinfoService.layerTypeList.find(i => i.id === d.gly_glt_id);
						bdryLayers.push({
							gltId: d.gly_glt_id,
							cateCode: d.glt_cd,
							label: cate.nameShort,
							layers: d.layers ? (<any[]>d.layers).map(l => {
								return {
									id: l.layer_id,
									state: this.mapTextToLayerLoadState(l.layer_state),
									maintainType: l.layer_maint_type
								}
							}) : []
							// layerIds: d.gly_ids 
						})
					})
				}
				this.bdryLayerList = bdryLayers;
				resolve(bdryLayers);
			}, err => reject(err));
		});
	}

	getRefLayerAttrList(cateCode: string, model: ModelMenuItemKey) {
		const info = this.appinfoService.refLayerMvtAttrs[cateCode];
		if (!info) {
			return '';
		}
		if (!model) {
			model = 'N';
		}
		if (!info[model]) {
			model = 'N';
		}
		const attrList = info[model].attrList;
		return attrList;
	}

	getFilterCount(layerId, extent?: number[], gfo?: Gfo) {
		return new Promise<number>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/filterCount';
			const params: any = {
				layerId: layerId
			};
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			if (extent) {
				params.xll = extent[0];
				params.yll = extent[1];
				params.xur = extent[2];
				params.yur = extent[3];
			}
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				resolve(rsp.data[0]);
			}, err => reject(err));
		});
	}

	getAddressTileMinDist(layerId: number, extent: number[], zoomLevel: number) {
		return new Promise<{
			dist: number;
			pt1: number[];
			pt2: number[];
		}>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/ssapDist';
			const params = {
				layerId: layerId,
				z: zoomLevel,
				xll: extent[0],
				yll: extent[1],
				xur: extent[2],
				yur: extent[3]
			}
			this.requestService.requestGet(url, {
				params
			}, rsp => {
				const wktFormat = new WKT();
				if (rsp.data.pt1) {
					rsp.data.pt1 = (<Point>wktFormat.readGeometry(rsp.data.pt1)).getCoordinates();
				}
				if (rsp.data.pt2) {
					rsp.data.pt2 = (<Point>wktFormat.readGeometry(rsp.data.pt2)).getCoordinates();
				}
				resolve(rsp.data);
			}, err => reject(err));
		});
	}
	getSsapByRcl(rcId, model?: ModelMenuItemKey) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/ssapByRcl';
			const cusId = this.userService.getCustomerIdByType();
			const params: any = {
				customerId: cusId,
				rclGrdId: rcId
			}
			if (model) {
				params.model = model;
			}
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				console.log(rsp);
				resolve(rsp);
			}, err => reject(err))
		});
	}
		// getRclBySsap(gadId, model?: ModelMenuItemKey) {
		// 	return new Promise<{addrGlobalId; rclGlobalId}[]>((resolve, reject) => {
		// 		const url = AppSettings.serviceRootUrl + 'azgiv/rclBySsap';
		// 		const cusId = this.userService.getCustomerIdByType();
		// 		const params: any = {
		// 			customerId: cusId,
		// 			ssapGadId: gadId
		// 		}
		// 		if (model) {
		// 			params.model = model;
		// 		}
		// 		this.requestService.requestGet(url, {
		// 			params: params
		// 		}, rsp => {
		// 			const list: {addrGlobalId; rclGlobalId}[] = [];
		// 			if (rsp.data) {
		// 				rsp.data.forEach(i => list.push({
		// 					addrGlobalId: i.gad_globalid,
		// 					rclGlobalId: i.grd_globalid
		// 				}));
		// 			}
		// 			resolve(list);
		// 		}, err => reject(err))
		// 	});
		// }

	getSourceTableNameByLayerCate(cateCode: string) {
		const layerType = this.appinfoService.layerTypeList.find(i => i.code === cateCode);
		return layerType ? layerType.tableName : '';
	}

	getLayerLabelByCateCode(cateCode: string) {
		if (!cateCode) {
			return '';
		}
		const layer = this.layerListBS.getValue().layers.find(l => l.category.code === cateCode);
		const name = layer.category.name;
		return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
	}
	// public async checkLayerNotFoundError(err, cusId, layerId) {
	// 	if (err.error && err.error.errorDetail === this.requestService.layerNotFoundErr) {
	// 		const layers = await this.getLayers(cusId, true);
	// 		const layer = layers.find(l => l.id === layerId);
	// 		if (!layer) {
	// 			await alert('Layer has been updated or deleted. Please refresh.');
	// 			this.router.navigate(['azgiv']);
	// 		}
	// 	}
	// }
}
